import Cookie from 'js-cookie'

import { SetStorageProps } from './types'

export const setCookie = ({ key, value }: SetStorageProps) => {
  return Cookie.set(key, value)
}

export const getCookie = (key: string) => {
  return Cookie.get(key)
}

export const deleteCookie = (key: string) => {
  return Cookie.remove(key)
}
